import { useState, MouseEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from 'styled-components';
import useDriverThumbnail from '../../../theme/useDriverThumbnail';
import Modal from '../../common/Modal/Modal';
import Tags from '../../common/Tags';
import { Button } from '../../ui/Button/Button';
import { ListItemWrapper } from '../../ui/ListItemWrapper/ListItemWrapper';
import { getFormattedDate } from '../../../utils/dateUtils';
import { IconKeys } from '../../common/Icon/IconKeys';
import { ThemeType } from '../../../theme/themeType';
import DeleteModal from '../../common/DeleteModal/DeleteModal';
import useDeleteDriver from '../../../API/hooks/vehicles/useDeleteAuthorizedDriver';
import { DriverAuthorizationRecord } from '../../../API/types/Vehicles';

type Props = {
  item: DriverAuthorizationRecord
};

function AuthorizedDriverItem({ item }: Props): JSX.Element {
  const theme = useTheme() as ThemeType;
  const driverThumbnail = useDriverThumbnail();
  const navigate = useNavigate();
  const [modalDeleteState, toggleModalDeleteState] = useState(false);
  const onSubmitSuccess = (): void => { };
  const onSubmitFail = (errorMessage: string): void => { };
  const { mutate: deleteDriver } = useDeleteDriver(onSubmitSuccess, onSubmitFail);

  const handleDeleteDriver = (e: MouseEvent<HTMLButtonElement>): void => {
    e.stopPropagation();
    toggleModalDeleteState(true);
  };

  const deleteDriverAction = (): void => {
    if (item) {
      deleteDriver({
        fleetId: item?.fleetId,
        recordId: item?._id,
      });
      toggleModalDeleteState(false);
    }
  };

  return (
    <>
      <ListItemWrapper onClick={() => navigate(`/drivers/${item.driverId}`)}>
        <Tags.ItemOverview
          avatar={item.driver?.avatarUrl || driverThumbnail}
          avatarAlt="driver"
          title={`${item.driver?.firstName} ${item.driver?.lastName}`}
          subtitle={item.driver?.licenseName || ''}
          isRoundImage
        />
        <Tags.LabeledIcon
          label={`Authorized since ${getFormattedDate(item.createdAt)}`}
          icon={IconKeys.DATE}
          flexible
        />
        <div className="tags-container">
          <Button
            height="26px"
            width="200px"
            padding="8px 8px"
            background={theme.colors.outline}
            hoverBackground={theme.colors.inactive}
            onClick={(e) => handleDeleteDriver(e)}
          >
            Remove authorization
          </Button>
        </div>
      </ListItemWrapper>
      {modalDeleteState && (
        <Modal
          title="Removing from authorized list"
          state={modalDeleteState}
          toggleState={toggleModalDeleteState}
          settings={{
            minWidth: '500px',
          }}
        >
          <DeleteModal
            title="Are you sure you want to remove this driver?"
            onClose={() => toggleModalDeleteState(false)}
            onDelete={deleteDriverAction}
            btnConfirmText="Remove"
          />
        </Modal>
      )}
    </>
  );
}

export default AuthorizedDriverItem;
